import { render, staticRenderFns } from "./RuleSection.vue?vue&type=template&id=9ebdc83c&scoped=true&lang=html&"
import script from "./RuleSection.vue?vue&type=script&lang=js&"
export * from "./RuleSection.vue?vue&type=script&lang=js&"
import style0 from "./RuleSection.vue?vue&type=style&index=0&id=9ebdc83c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ebdc83c",
  null
  
)

export default component.exports